import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';

let EcomDetails = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Ecom details'>
            {service.order.billingAddress &&
                <Grid container>
                    <Grid item xs={3}>
                        <Typography>Sales area code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.ecom.salesAreaCode}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Backoffice operator email</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.ecom.backofficeOperatorEmail}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Payment type</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.ecom.paymentType}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Payment status</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.ecom.paymentStatus}</Typography>
                    </Grid>
                </Grid>
            }
        </DetailsPageHeader>
    );
}

export default EcomDetails;